export const YELLOW_COLOR = "#f8d829";
export const DARK_YELLOW_COLOR = "#d8b429";

export const BLUE_COLOR = "#15abcf";
export const DARK_BLUE_COLOR = "#0d91ae";

export const BEDROOMS = [1, 2, 3, 4, 5];
export const MIN_PRICES = [10_000, 20_000, 30_000, 40_000, 50_000, 60_000];
export const MAX_PRICES = [20_000, 30_000, 40_000, 50_000, 60_000, 250_000, 500_000];

export const BREAKFREE_HOLIDAYS_IMAGE = "https://www.breakfreeholidays.co.uk/static/media/logo-new-style.e9a55b96.svg";
export const BREAKFREE_HOLIDAYS_IMAGE_DARK_MODE =
  "https://www.breakfreeholidays.co.uk/static/media/logo-dark.542dd7a2.svg";

export const NAV_HEIGHT = "106px"; // With the blue bar
export const PURE_NAV_HEIGHT = "63px"; // Without the blue bar
export const minContentH = `calc(100vh - ${NAV_HEIGHT})`;

export const API_BASE_URL = "/api";
export const FORM_SUBMITTING_TEXT = "Submitting...";

// Not sure why this is so specific, copied from BFH
export const TEXT_SHADOW = "0 3px 6px rgba(0,0,0,.1607843137254902)";
export const BOX_SHADOW = "0 .125rem .25rem rgba(91,91,90,0.125)";

export const MAX_CONTENT_WIDTH = "1400px";
export const SITE_MIN_MARGIN = 4;
export const MAX_CONTENT_WIDTH2 = "1432px";

export const BLACK_BG_COLOR = "#5b5b5a !important";

const MILLISECONDS_IN_SECOND = 1000;
const SECONDS_IN_MINUTE = 60;
const MINUTES_IN_HOUR = 60;
const HOURS_IN_DAY = 24;

export const ONE_MINUTE = MILLISECONDS_IN_SECOND * SECONDS_IN_MINUTE;
export const ONE_HOUR = ONE_MINUTE * MINUTES_IN_HOUR;
export const ONE_DAY = ONE_MINUTE * MINUTES_IN_HOUR * HOURS_IN_DAY;

export const MODAL_OVERLAY_DARKNESS = "blackAlpha.700";

export const LIVE_URL = "https://holidayhomes.breakfreeholidays.co.uk";

export const IMAGE_PATH = process.env.NODE_ENV === "development" ? `${LIVE_URL}/images` : "/images";

export const GOOGLE_MAPS_KEY = "AIzaSyB7PsauX1x8tFPwX-6zd5BSVvFHBtuRclc";

// To be used with text coming from api's that contains html elements like <p>
export const PARAGRAPH_SPACING = {
  p: {
    mb: 4,
    ":last-of-type": {
      mb: 0,
    },
  },
};
